// backpack.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_BACKPACK_ITEMS,
  LOGOUT,
  MERGE_BACKPACK_ITEMS,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Backpack.
 * @module reducer/backpack
 */
const backpack = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_BACKPACK_ITEMS:
      return _ADD_BACKPACK_ITEMS(action.payload)(state);
    case MERGE_BACKPACK_ITEMS:
      return _MERGE_BACKPACK_ITEMS(action.payload)(state);
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add backpack items
 * @kind reducer/actionType
 * @name _ADD_BACKPACK_ITEMS
 * @param {object} {backpackItems} - backpack items
 * @return {Immutable.Map} New state
 */
const _ADD_BACKPACK_ITEMS =
  ({ backpackItems }) =>
  state => {
    return state.mergeDeep(backpackItems);
  };

/**
 * merge backpack items
 * @kind reducer/actionType
 * @name _MERGE_BACKPACK
 * @param {object} {data} - backpack items
 * @return {Immutable.Map} New state
 */
const _MERGE_BACKPACK_ITEMS =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default backpack;
